export const BASE_PATH = '/dashboard';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/constants.ts